import { render, staticRenderFns } from "./MrfEventsCreate.vue?vue&type=template&id=566187fe"
import script from "./MrfEventsCreate.vue?vue&type=script&lang=js"
export * from "./MrfEventsCreate.vue?vue&type=script&lang=js"
import style0 from "./MrfEventsCreate.vue?vue&type=style&index=0&id=566187fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports